import { render, staticRenderFns } from "./_regions.vue?vue&type=template&id=b93ef1ea&"
import script from "./_regions.vue?vue&type=script&lang=js&"
export * from "./_regions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports